<template>
    <div>
        <div class="field">
            <div class="control">
                <router-link class="button is-success" :to="{'name':'client-content-links-create', params: { clientId: clientId }}">Create link</router-link>
            </div>
        </div>

        <content-links-list :items="items" :reload="reload" />
    </div>
</template>
<script>
import contentService from '../../../../../services/content.service'

import ContentLinksList from '../../../../common/content/link/content-link-list.vue'

export default {
    name: 'system-content-links',
    components: { ContentLinksList },
    data() {
        return {
            items: []
        }
    },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        }
    },
    async created() {
        await this.reload();
    },
    methods: {
        async reload() {
            this.items = await contentService.listLinks(this.clientId);
        }
    }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/content/links/list.vue